import { AbstractControl, ValidatorFn } from '@angular/forms'

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): Record<string, any> | null => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    const valid = emailRegex.test(control.value)
    return valid ? null : { invalidEmail: { value: control.value } }
  }
}
